/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierCrmStage {
  Prospect = "prospect",
  Qualified = "qualified",
  Onboarding = "onboarding",
  Active = "active",
  NotInterested = "not_interested",
  Disqualified = "disqualified",
  Bankrupt = "bankrupt",
}

export function instanceOfCarrierCrmStage(value: any): boolean {
  for (const key in CarrierCrmStage) {
    if (Object.prototype.hasOwnProperty.call(CarrierCrmStage, key)) {
      if (CarrierCrmStage[key as keyof typeof CarrierCrmStage] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierCrmStageFromJSON(json: any): CarrierCrmStage {
  return CarrierCrmStageFromJSONTyped(json, false);
}

export function CarrierCrmStageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierCrmStage {
  return json as CarrierCrmStage;
}

export function CarrierCrmStageToJSON(value?: CarrierCrmStage | null): any {
  return value as any;
}

export function CarrierCrmStageToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierCrmStage {
  return value as CarrierCrmStage;
}
